<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/accounting/journals">{{ $t('general_journal')}}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{ $t('save') }}</button> 
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('entry_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.RefNum" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                    <tr>
                                        <th>{{$t('account_name')}}</th>
                                        <th>{{$t('partner')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('debit')}}</th>
                                        <th class="text-right" style="width: 120px;">{{$t('credit')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td>
                                            <CoaSelect :value="ret.AccountName" @select="coaSelect(ret, $event)"></CoaSelect>
                                        </td>
                                        <td>
                                            <div type="text"
                                               class="form-control form-control-sm"
                                            @click="onPartner(index)">
                                                <span>{{ret.ParterName}}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <input type="text"
                                               class="form-control form-control-sm"
                                               v-model="ret.Description"/>
                                        </td>
                                        <td><input type="number"
                                               class="form-control form-control-sm text-right"
                                               v-model="ret.Debit" @blur="calculate"/>
                                        </td>
                                        <td><input type="number"
                                               class="form-control form-control-sm text-right"
                                               v-model="ret.Credit" @blur="calculate"/>
                                        </td>
                                        <td><a href="javascript:void(0)" class="red" @click="removeLine(index)"><i aria-hidden="true" class="fa fa-times-circle"></i></a></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th class="none-left" colspan="3">
                                            <button type="button"
                                                class="btn btn-outline-primary btn-sm no-bor"
                                                @click="addLine"><i class="fa fa-plus"/> {{ $t('add_line') }}
                                            </button>
                                        </th>
                                        <th class="text-right">{{$money(footer.TotalDebit)}}</th>
                                        <th class="text-right">{{$money(footer.TotalCredit)}}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import CoaSelect from './CoaSelect';
export default {
    components: { CoaSelect },
    data(){
        return{
            title: this.$t('general_journal_create'),
            header: {
                TypeNo: 'General Journal',
                Date: this.$now().format('YYYY-MM-DD'),
                RefNum: ''
            },
            lines: [
                {
                    AccountId: '',
                    AccountName: '',
                    ParterType: '',
                    ParterNum: '',
                    ParterName: '',
                    Description: '',
                    Debit: 0,
                    Credit: 0
                }
            ],
            footer: {
                TotalDebit: 0,
                TotalCredit: 0
            }
        }
    },
    mounted(){
        let id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.title = this.$t('general_journal_update');
            this.findById(id);
        }
    },
    methods: {
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('accounting/generaljournal/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.header = res.data.Json.Header;
                    this.header.Date = this.$format(this.header.Date, 'YYYY-MM-DD');
                    this.lines = res.data.Json.Lines;
                    this.calculate();
                }
            }).finally(() => { loading.hide(); });
        },
        onSave(){
            if(this.lines.length < 2){
                Swal.fire(this.$t('waring_message'), 'នៅក្នុងមួយប្រតិបត្តការណ៍យ៉ាងតិច២គណនី', 'warning');
                return;
            }
            for(var i = 0;i < this.lines.length;i++){
                var line = this.lines[i];
                if(line.AccountId == ''){
                    Swal.fire(this.$t('waring_message'), this.$t('error.account_id_empty'), 'warning');
                    return;
                }else if(line.Debit == 0 && line.Credit == 0){
                    Swal.fire(this.$t('waring_message'), 'Debit and Credit can not input both 0', 'warning');
                    return;
                }
            }
            if(this.footer.Debit != this.footer.Credit){
                Swal.fire(this.$t('waring_message'), 'Total debit and credit must be equal.', 'warning');
                return;
            }
            var req = {
                Header: this.header,
                Lines: this.lines
            };
            var loading = this.$loading.show();
            this.$api().post('accounting/generaljournal', req).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(() => { loading.hide(); });
        },
        onPartner(){
            alert('OK');
        },
        addLine(){
            this.lines.push({
                AccountId: '',
                AccountName: '',
                ParterType: '',
                ParterNum: '',
                ParterName: '',
                Description: '',
                Debit: 0,
                Credit: 0
            });
        },
        removeLine(index){
            this.lines.splice(index, 1);
        },
        calculate(){
            var debits = 0;
            var credits = 0;
            this.lines.forEach(item => {
                debits += Number(item.Debit);
                credits += Number(item.Credit);
            });
            this.footer.TotalDebit = debits;
            this.footer.TotalCredit = credits;
        },
        coaSelect(line, sender){
            line.AccountId = sender.Id;
            line.AccountName = sender.Name;
        }
    }
}
</script>